module.exports = __webpack_public_path__ + "img/已售馨.7aa12245.png";